import React from 'react'
import { ClipLoader } from 'react-spinners'

export default function Loader({size = 100, color = '#008ace'}: {size?: number, color?: string}) {
    return (
        <div style={{justifyContent: 'center', alignItems: 'center', height: '100%'}}>
            <ClipLoader color={color} loading size={size} />
        </div>
    )
}